import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functionsClient, hasRequiredFirebaseConfig, missingFirebaseConfigKeys } from "../firebase";

export async function submitContactInquiry(formData, captchaToken) {
  if (!hasRequiredFirebaseConfig) {
    throw new Error(
      `Firebase is not configured. Missing env keys: ${missingFirebaseConfigKeys.join(", ")}.`
    );
  }

  const payload = {
    fullName: formData.fullName.trim(),
    workEmail: formData.workEmail.trim().toLowerCase(),
    company: formData.company.trim(),
    service: formData.service,
    budget: formData.budget,
    timeline: formData.timeline,
    details: formData.details.trim(),
    captchaToken,
    website: formData.website || ""
  };

  if (functionsClient) {
    try {
      const submitInquiry = httpsCallable(functionsClient, "submitContactInquiry");
      await submitInquiry(payload);
      return { mode: "cloud_function" };
    } catch (error) {
      const code = String(error?.code || "");
      const shouldFallbackToFirestore =
        code.includes("not-found") || code.includes("unavailable") || code.includes("internal");

      if (!shouldFallbackToFirestore) {
        throw error;
      }
    }
  }

  if (!db) {
    throw new Error("Submission service is currently unavailable.");
  }

  try {
    await addDoc(collection(db, "contactInquiries"), {
      fullName: payload.fullName,
      workEmail: payload.workEmail,
      company: payload.company,
      service: payload.service,
      budget: payload.budget,
      timeline: payload.timeline,
      details: payload.details,
      source: "website_contact_form",
      status: "new",
      createdAt: serverTimestamp()
    });
  } catch (error) {
    const code = String(error?.code || "");

    if (code.includes("permission-denied")) {
      throw new Error(
        "Something went wrong...."
      );
    }

    throw error;
  }

  return { mode: "firestore_direct" };
}
